module.exports = __webpack_public_path__ + "static/jad-cover-ee5a6407024dfd70b65d0bc836e4aa4b.png";